export default "__VITE_ASSET__CPY22hBk__"